export default __webpack_public_path__ + "static/media/filter_news_annoucement.2eda14a2.svg";